export default {
  id: "df433917-87af-4eae-b9b0-cb574aed3ee4", // create new uuid
  name: "template",
  icon: "mdi-calendar-blank", // choose a material design icon
  title: "Template",
  description: "a template"
}
